'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import styled from 'styled-components'

export const HeaderWrapper = styled.div<{ isMobile: boolean; scrollShadow: boolean; widgetModal?: boolean }>`
  padding: ${({ isMobile }) => (isMobile ? '15px 20px 10px 20px' : '10px 100px')};
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  height: ${({ isMobile }) => (isMobile ? '3.75rem' : '4.5rem')};
  z-index: 101;
  position: ${props => (props.widgetModal ? 'static' : 'sticky')};
  top: 0;
  background: #fff;
  flex-shrink: 1;
  box-shadow: ${({ scrollShadow }) => (scrollShadow ? '0 0.5px 10px 2px rgb(0 0 0 / 9%)' : 'none')};
`

export const MenuLogoHeaderWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex-shrink: 1;
  align-items: center;
  gap: ${({ isMobile }) => (!isMobile ? '66px' : '10px')};
`

export const SearchIconWrapper = styled.div<{ alignRight? }>`
  display: flex;
  justify-content: ${props => (props.alignRight ? 'flex-end' : 'center')};
  align-items: center;

  animation-name: animateSearchIcon;
  animation-duration: 0.3s;
  animation-timing-function: ease-in;
  @keyframes animateSearchIcon {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`
